// extracted by mini-css-extract-plugin
export default {"mainContainer":"mainContainer___sT0Df","filtersContainer":"filtersContainer___GzZBD"};